import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";

import { toAbsoluteUrl } from "_metronic";

import "_metronic/_assets/sass/pages/error/error.scss";

export default function ErrorPage() {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleGoHome = () => {
    navigate("/");
  };

  return (
    <main role="main" aria-labelledby="error-title" className="kt-grid kt-grid--ver kt-grid--root">
      <div
        className="kt-grid__item kt-grid__item--fluid kt-grid  kt-error-v5"
        style={{
          backgroundImage: `url(${toAbsoluteUrl("/media/error/bg5.jpg")})`,
        }}
        role="img"
        aria-label="Error page background"
      >
        <div className="kt-error_container">
          <header>
            <h1 id="error-title" className="kt-error_title">
              <FormattedMessage id="ERROR_PAGE.TITLE" />
            </h1>
          </header>
          <p className="kt-error_subtitle" role="alert">
            <FormattedMessage id="ERROR_PAGE.SUBTITLE" />
          </p>
          <p className="kt-error_description">
            <FormattedMessage id="ERROR_PAGE.DESCRIPTION" />
          </p>
          <nav aria-label="Error page navigation" className="mt-4">
            <button
              type="button"
              className="btn btn-primary mr-3"
              onClick={handleGoBack}
              aria-label="Go back to previous page"
            >
              <FormattedMessage id="ERROR_PAGE.BACK_BUTTON" />
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleGoHome}
              aria-label="Go to home page"
            >
              <FormattedMessage id="ERROR_PAGE.HOME_BUTTON" />
            </button>
          </nav>
        </div>
      </div>
    </main>
  );
}
